import React from 'react';
import Helmet from 'react-helmet';

function Meta ({ metaTitle, description, metaImage, url, title, siteUrl, ...props }) {
  const analytics = `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'UA-58217635-2');
              `;
  return (
    <Helmet>
      <title>{`${metaTitle}`}</title>
      <meta property="og:title" content={`${metaTitle}`} />
      <meta name="twitter:title" content={`${metaTitle}`} />
      {description &&
        [
          <meta key={`desc`} name="description" content={description} />,
          <meta key={`og-desc`} property="og:description" content={description} />,
          <meta key={`twitter-desc`} name="twitter:description" content={description} />,
        ]
      }
      {url
        ? (<meta property="og:url" content={`${siteUrl}${url}`} />)
        : (<meta property="og:url" content={`${siteUrl}`} />)
      }
      {metaImage &&
        [
          <meta key="og-image" property="og:image" content={metaImage.url} />,
          <meta key="twitter-img" name="twitter:image" content={metaImage.url} />
        ]
      }
      {url &&
        <link rel="canonical" href={`${siteUrl}${url}`} />
      }
      <meta property="og:type" content="website"/>
      <meta name="twitter:card" content="summary"/>
      <script async src="https://www.googletagmanager.com/gtag/js?id=UA-58217635-2" />
      <script key="analytics">{analytics}</script>
    </Helmet>
  );
}

export default Meta;

export const metaFragment = graphql`
  fragment ArticleMeta on ArticleJson {
    meta_title
    meta_image {
      url
    }
  }
  fragment CaseMeta on CaseJson {
    meta_title
    meta_image {
      url
    }
  }
  fragment IndexMeta on IndexJson {
    meta_title
    meta_image {
      url
    }
  }
  fragment NavMeta on NavigationJson {
    meta_title
    meta_image {
      url
    }
  }
  fragment SiteMeta on Site {
    siteMetadata {
      siteUrl
      title
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Meta/index.jsx